module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "select",
    staticClass: "mdl-selectfield mdl-js-selectfield mdl-selectfield--floating-label"
  }, [_c('select', {
    staticClass: "mdl-selectfield__select",
    attrs: {
      "id": _vm.id
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }, _vm._l((_vm.options), function(option, idx) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  })), _vm._m(0, false, false), _c('label', {
    staticClass: "mdl-selectfield__label",
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-selectfield__icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a07891d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/form/Selectfield.vue
// module id = 506
// module chunks = 1